import { observer } from 'mobx-react';
import React, { useMemo, useState } from 'react';
import itemsStore from '../../store/itemsStore';
import ItemCrossSellingItems from '../ItemCrossSellingItems/ItemCrossSellingItems';
import { localeStore } from 'src/mobx/localesStore';
import { modalStore } from 'src/mobx/modalStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import { TOOLTIP_DURATION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import Text, { TEXT } from 'src/view/components/Text/Text';
import TooltipIcon from '~/view/components/TooltipIcon/TooltipIcon';
import './style.scss';

const ItemsCrossSelling: React.FC = observer((): JSX.Element | null => {
  const [tooltip, setTooltip] = useState<boolean>(false);

  const openCrossSellingModal = () => {
    if (!itemsAvailable) {
      setTooltip(true);
    } else {
      modalStore.openCrossSellingModal({
        itemId: itemsStore.item?.id || undefined,
        selectedItems: itemsStore.crossSellingItems || [],
        onSave: itemsStore.addCrossSellingItems,
      });
    }
  };

  const itemsAvailable = useMemo((): boolean => {
    if (!itemsStore.itemsCount) return false;

    return Boolean(itemsStore.item?.is_draft ? itemsStore.itemsCount : itemsStore.itemsCount - 1);
  }, [itemsStore.itemsCount, itemsStore.item?.is_draft]);

  if (!itemsStore.item) return null;

  return (
    <div className="d-flex flex-column mt-6">
      <Text type={TEXT.SECTION_HEADER} text="cross_selling_items" />

      <ul className="items-cross-selling__list mt-2">
        <ItemCrossSellingItems />

        <div className="d-flex flex-row align-items-center mt-2">
          <Button
            title={localeStore.t('add_items')}
            onClick={openCrossSellingModal}
            disabled={!itemsAvailable}
            appearance="secondary"
            className="items-cross-selling__btn-add"
          />

          {!itemsAvailable ? (
            <TooltipIcon
              message="no_items_yet"
              trigger={tooltip}
              disableTrigger={() => setTooltip(false)}
              duration={TOOLTIP_DURATION.EXTRA_LARGE}
              maxWidth={385}
              iconClassName="ml-3"
            />
          ) : null}
        </div>
      </ul>
    </div>
  );
});

export default ItemsCrossSelling;
